import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { StoragePlace } from '../storage-place';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Storage } from '../../storage/storage';
import { StoragePlaceService } from '../storage-place.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-edit-storage-place-dialog',
    templateUrl: './edit-storage-place-dialog.component.html',
    styleUrls: ['./edit-storage-place-dialog.component.scss'],
})
export class EditStoragePlaceDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<EditStoragePlaceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private storageService: StoragePlaceService,
    ) {
        this.storagePlace = data.storagePlace;
    }

    storagePlace = new StoragePlace();
    nameCtrl = new UntypedFormControl('', [Validators.required]);
    storageCtrl = new UntypedFormControl('', [Validators.required]);
    storages: Storage[] = [];

    ngOnInit() {
        this.loadStorages();
        this.nameCtrl.setValue(this.storagePlace.bezeichnung);
    }

    loadStorages() {
        this.storageService.getLagers().subscribe(storages => {
            this.storages = storages.records;
            this.applyStorageSelection();
        });
    }

    storageComparator(one: number, two: number): boolean {
        return KieneUtils.sameId(one, two);
    }

    private applyStorageSelection(): void {
        const lagerId = this.storagePlace?.lager_id;
        if (lagerId == null || !this.storages?.length) {
            return;
        }
        const match = this.storages.find(s => KieneUtils.sameId(s.lager_id, lagerId));
        if (match) {
            this.storageCtrl.setValue(match.lager_id);
        }
    }

    create() {
        this.storagePlace.bezeichnung = this.nameCtrl.value;
        this.storagePlace.lager_id = this.storageCtrl.value;
        this.dialogRef.close(this.storagePlace);
    }

    cancel() {
        this.dialogRef.close(null);
    }
}
